import {auth0Client} from './react-auth0-spa';
import {config} from './config';

const parseJwt = (token: string): any => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    const payload = JSON.parse(jsonPayload);

    // Normalize namespaced "roles" to just "roles"
    const rolesKey = Object.keys(payload).find(key => key.endsWith('/roles'));
    if (rolesKey && Array.isArray(payload[rolesKey])) {
        payload.roles = payload[rolesKey];
    }

    return payload;
};

export const getToken = (): Promise<string> => {
    // @ts-ignore
    return auth0Client.getTokenSilently({ authorizationParams: { audience: config.auth0.audience } });
};

export const getTokenData = async (): Promise<{ permissions: string[], roles: string[] }> => {
    const token = await getToken();
    return parseJwt(token);
};
